<template>
  <div id="subpage" v-loading="loading">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <b>厂商管理</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item to="/customer/index">客户列表</el-breadcrumb-item>
        <el-breadcrumb-item>添加客户</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <div class="content">
      <div class="xcx-head">
        <span class="title">添加客户</span>
      </div>
      <div class="xcx-content">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" style="width: 80%">
          <el-form-item label="厂商名称：" prop="title">
            <el-col :span="20">
              <el-input placeholder="请填写厂商名称" v-model="ruleForm.title"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="品牌：" prop="brand">
            <el-col :span="20">
              <el-input placeholder="请填写品牌" v-model="ruleForm.brand"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="房车型号：" prop="car_model">
            <el-col :span="20">
              <el-input placeholder="请填写房车型号" v-model="ruleForm.car_model"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="设备型号：" prop="dev_model">
            <el-col :span="20">
              <el-input placeholder="请填写设备型号" v-model="ruleForm.dev_model"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="在线数量：" prop="nums">
            <el-col :span="20">
              <el-input placeholder="请填写在线数量" v-model="ruleForm.nums"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="入库日期：" prop="stime">
            <el-col :span="20">
              <el-date-picker v-model="ruleForm.stime" type="datetime" placeholder="选择日期时间"></el-date-picker>
            </el-col>
          </el-form-item>
          <el-form-item label="激活日期：" prop="etime">
            <el-col :span="20">
              <el-date-picker v-model="ruleForm.etime" type="datetime" placeholder="选择日期时间"></el-date-picker>
            </el-col>
          </el-form-item>
          <el-form-item label="出厂日期：" prop="ctime">
            <el-col :span="20">
              <el-date-picker v-model="ruleForm.ctime" type="datetime" placeholder="选择日期时间"></el-date-picker>
            </el-col>
          </el-form-item>
          <el-form-item label="用户激活日期：" prop="atime">
            <el-col :span="20">
              <el-date-picker v-model="ruleForm.atime" type="datetime" placeholder="选择日期时间"></el-date-picker>
            </el-col>
          </el-form-item>
          <el-form-item label="备注：" prop="desc">
            <el-col :span="20">
              <el-input placeholder="请填备注" type="textarea" v-model="ruleForm.desc"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item>
            <div style="width: 100%; height: 15px"></div>
            <el-button type="primary" @click="submitForm('ruleForm')" v-if="id">确认修改</el-button>
            <el-button type="primary" @click="submitForm('ruleForm')" v-else>确认添加</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import BaseEditor from "../../components/editer/Editer";
import VueUeditorWrap from "vue-ueditor-wrap";
export default {
  props: ["isEdit"],
  components: {
    BaseEditor,
    VueUeditorWrap,
  },
  data() {
    return {
      loading: true,
      id: "",
      content: "",
      ruleForm: {
        title: "",
        brand: "",
        car_model: "",
        dev_model: "",
        nums: "",
        stime: "",
        etime: "",
        ctime: "",
        atime: "",
        desc: "",
      },
      rules: {
        title: [{ required: true, message: "请输入厂商名称", trigger: "blur" }],
        brand: [{ required: true, message: "请填写品牌", trigger: "blur" }],
      },
    };
  },

  /**
   * 进入页面加载
   */
  mounted() {
    var that = this;
    var query = that.$route.query;
    if (query.id) {
      that.id = query.id;
      that.getDetail();
    }
    // that.getCate();
    that.loading = false;
  },
  methods: {
    /**
     * 获取详情
     */
    getDetail() {
      var that = this;
      that.axios.post("/customer/edit", { id: that.id }).then((res) => {
        if (res) {
          that.ruleForm = res.data;
        }
      });
    },
    submitForm(formName) {
      const that = this;
      that.$refs[formName].validate((valid) => {
        if (!valid) return that.$message.warning("请完整填写内容!");
        var formData = {};
        formData = that.ruleForm;
        var url = "/customer/store";
        if (that.id) {
          formData.id = that.id;
          url = "/customer/update";
        }
        that.axios.post(url, formData).then(() => {
          that.$message.success(that.id ? "修改成功" : "添加成功");
          that.$router.push("/customer/index");
        });
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    /**
     * 返回
     */
    back() {
      this.$router.push("/customer/index");
    },
  },
};
</script>
<style>
.edui-default {
  line-height: 20px;
}

.line {
  text-align: center;
}
</style>